import { OmneaError } from '@omnea-digital/toolbox'
import type { RecordPermissionsEntity } from '@omnea-digital/authz-model'

type RecordPermissionsResponseDetail =
  | { reason: 'noBody'; entity: RecordPermissionsEntity; recordId: string }
  | { reason: 'notAnswered'; entity: RecordPermissionsEntity; recordId: string }
  | { reason: 'noBatchBody'; entity: RecordPermissionsEntity; recordIds: readonly string[] }
  | {
      reason: 'answeredForAnotherEntity'
      entity: RecordPermissionsEntity
      recordId: string
      answeredFor: RecordPermissionsEntity
    }

export class RecordPermissionsResponseError extends OmneaError<
  'RecordPermissionsResponseError',
  RecordPermissionsResponseDetail
> {
  readonly type = 'RecordPermissionsResponseError'

  constructor(detail: RecordPermissionsResponseDetail) {
    super({ message: 'The permissions service did not answer for the record that was asked about', detail })
  }
}
